import styled from "styled-components";
import { FlexGrowProps } from "styled-system";

import Box from "../Box";
import { Link } from "react-router-dom";
import { CText } from "@carrefour/design-system-components-react";

type BarProps = {
  isActive: boolean;
  tabName: string;
  page: string;
  bg?: string;
} & FlexGrowProps;
interface ComponentProps {
  $isActive: boolean;
}
const BarContainer = styled(Box)`
  cursor: pointer;
  display: flex;
  align-items: end;
`;
const Text = styled(CText)<{ color: string }>`
  font-family: system-ui;
  color: ${(props) => props.color};
`;

const LinkCustom = styled(Link)<ComponentProps>`
  text-decoration: none;
  height: 100%;
`;

const Bar = ({ tabName, page, isActive, bg }: BarProps) => {
  return (
    <LinkCustom data-testid={tabName} to={page} $isActive={isActive}>
      <BarContainer
        minWidth={65}
        display={"flex"}
        justifyContent={"center"}
        height="100%"
        p="6px 16px"
        bg={isActive ? "blueMedium" : bg ? bg : "white"}
        borderRadius={"4px"}
      >
        <Text size={"m"} bold tagStyle="p" color={isActive ? "white" : "black"}>
          {tabName}
        </Text>
      </BarContainer>
    </LinkCustom>
  );
};

export default Bar;
